import React from 'react';
import Layout from 'antd/es/layout';
import Menu from 'antd/es/menu';
import homeIcon from "../../../images/Home_svg.svg";
import { Link } from 'react-router-dom';
import './DiagnosticSideNav.css';
import { ROUTES } from 'utils/constants';

const { Sider } = Layout;
const imgStyle = { height: 20, width: 20 };

const menuItems = [
  {
    key: 'home',
    icon: <img style={imgStyle} src={homeIcon} alt="icon" />,
    label: <Link to={ROUTES.DIAGNOSTICS_HOME}>Home</Link>,
  },
];

const DiagnosticSideNav: React.FC = () => (
  <Sider width={230} theme="light" className="diagnostics-sidenav">
    <Menu
      mode="inline"
      defaultSelectedKeys={['home']}
      style={{ height: '100%', borderRight: 0 }}
      items={menuItems}
    />
  </Sider>
);

export default DiagnosticSideNav; 